/**
 * Catálogo único de idiomas globais da UI (arquivos estáticos em src/i18n/locales/{code}/).
 *
 * Novo idioma (ex.: chinês, russo):
 * 1. Copie a pasta pt-BR (ou en) para locales/{code}/ com os mesmos *.json.
 * 2. Inclua uma linha abaixo com `code` (BCP-47) e `nativeName` (rótulo no select).
 *
 * Só entram no select e no i18next os idiomas que tiverem todos os namespaces EAGER preenchidos.
 *
 * Campanhas: ?lang=es (ou ?locale=, ?lng=, ?ui_lang=) em qualquer rota — ver urlLocale.js / UrlLocaleSync.jsx.
 */

export const GLOBAL_UI_LOCALES = [
  { code: "pt-BR", nativeName: "Português (Brasil)" },
  { code: "en", nativeName: "English" },
  { code: "es", nativeName: "Español" },
  { code: "it", nativeName: "Italiano" },
  // { code: "zh-CN", nativeName: "简体中文" },
  // { code: "ru", nativeName: "Русский" },
  // { code: "el", nativeName: "Ελληνικά" },
];

export const GLOBAL_LOCALE_CODES = GLOBAL_UI_LOCALES.map((x) => x.code);

/**
 * Resolve entrada do catálogo para um código salvo (ex.: en-US → en se existir en).
 */
export function resolveGlobalLocaleMeta(requested) {
  const r = String(requested || "").trim();
  if (!r) return GLOBAL_UI_LOCALES[0] || { code: "pt-BR", nativeName: "pt-BR" };

  const rl = r.toLowerCase();
  const exact = GLOBAL_UI_LOCALES.find((x) => x.code.toLowerCase() === rl);
  if (exact) return exact;

  const prefix = GLOBAL_UI_LOCALES.find(
    (x) => rl.startsWith(x.code.toLowerCase() + "-") || rl.startsWith(x.code.toLowerCase() + "_")
  );
  if (prefix) return prefix;

  const base = rl.split(/[-_]/)[0];
  const byBase = GLOBAL_UI_LOCALES.find((x) => x.code.toLowerCase() === base);
  if (byBase) return byBase;

  return null;
}

/** Rótulo amigável para select / rodapé; se o código não estiver no catálogo, devolve o próprio código. */
export function getBuiltinNativeLabel(code) {
  const m = resolveGlobalLocaleMeta(code);
  if (m) return m.nativeName;
  return String(code || "pt-BR").trim() || "pt-BR";
}
